import { Flex } from '@components/Flex';
import React, { useState, useEffect } from 'react';
import { JoykitIcon } from '@components/JoykitIcon';
import { TRANSITION_INTERVAL } from 'src/layout/Layout.constants';
import { useShopStorefrontContext } from '@utils/storefront/ShopStorefrontProvider';
import { StyledNavPropsButton, ValuePropsContainer, ValuePropsContent } from './ValueProps.styles';

interface ValuePropsProps {
  toggleValueProps: () => void;
}

export const ValueProps: React.FC<ValuePropsProps> = ({ toggleValueProps }) => {
  const { config } = useShopStorefrontContext();
  const [activeValuePropVariant, setActiveValuePropVariant] = useState<number>(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveValuePropVariant(prev => (prev + 1) % config.valuePropCardsData.length);
    }, TRANSITION_INTERVAL);
    return () => clearInterval(interval);
  }, [config.valuePropCardsData]);

  return (
    <StyledNavPropsButton active={false} id="universalNavValuePropsBtn" variant="defaultPrimary" onClick={toggleValueProps}>
      {config.valuePropCardsData.map((card, idx) => (
        <ValuePropsContainer key={idx}>
          <ValuePropsContent show={idx === activeValuePropVariant}>
            <Flex>{card.title}</Flex>
            <JoykitIcon name="forwardChevron" color="white" size={16} />
          </ValuePropsContent>
        </ValuePropsContainer>
      ))}
    </StyledNavPropsButton>
  );
};
